<template>
    <div class="look">
        <Head />
        <div class="banner">
            <div class="box">
                <div class="left animated fadeIn">
                    <img src="../../assets/look/overview_look_logo.png" alt="">
                    <div class="title">{{$t('look.col1.i1')}}</div>
                    <p>{{$t('look.col1.i2')}}</p>
                    <p>{{$t('look.col1.i3')}} </p>
                    <p>{{$t('look.col1.i4')}}</p>
                </div>
                <div class="right animated fadeIn">
                    <img src="../../assets/look/look_top_device.png" alt="">
                </div>
            </div>
        </div>
        <div class="pain-points node-anchor"  ref="animate2">
            <div class="box">
                <h1 :class="{'animated fadeInDown': animate2}">{{$t('look.col2.i1')}}</h1>
                <ul :class="{'animated fadeInDown delay-1s': animate2}">
                    <li>
                        <img src="../../assets/look/look_icon1.png" alt="">
                        <div class="info">
                            <p>{{$t('look.col2.i2')}}</p>
                        </div>
                        <div class="box-desc">
                            <p>{{$t('look.col2.i3')}}</p>
                            <p>{{$t('look.col2.i4')}}</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../assets/look/look_icon2.png" alt="">
                        <div class="info">
                            <p>{{$t('look.col2.i5')}}</p>
                        </div>
                        <div class="box-desc">
                            <p>{{$t('look.col2.i6')}} </p>
                            <p>{{$t('look.col2.i7')}}</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../assets/look/look_icon3.png" alt="">
                        <div class="info">
                            <p>{{$t('look.col2.i8')}}</p>
                        </div>
                        <div class="box-desc">
                            <p>{{$t('look.col2.i9')}}</p>
                            <p>{{$t('look.col2.i10')}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="product" ref="animate3">
            <h3 :class="{'animated fadeInDown': animate3}">{{$t('look.col2.i11')}}</h3>
            <div class="box">
                <div class="left" :class="{'animated fadeInDown delay-1s': animate3}">
                    <div>
                        <img src="../../assets/look/look_overview_pic.jpg" alt="">
                    </div>
                    <div>
                        <p>{{$t('look.col2.i12')}}</p>
                        <p>{{$t('look.col2.i13')}}</p>
                    </div>
                </div>
                <div class="right" :class="{'animated fadeInDown delay-1s': animate3}">
                    <h4>{{$t('look.col2.i14')}}</h4>
                    <ul>
                        <li>
                            <img src="../../assets/look/look_features_icon1.png" alt="">
                            <p>{{$t('look.col2.i15')}}</p>
                        </li>
                        <li><img src="../../assets/look/look_features_icon2.png" alt=""><p>{{$t('look.col2.i16')}}</p></li>
                        <li><img src="../../assets/look/look_features_icon3.png" alt=""><p>{{$t('look.col2.i17')}}</p></li>
                        <li><img src="../../assets/look/look_features_icon4.png" alt=""><p>{{$t('look.col2.i18')}}</p> </li>
                        <li><img src="../../assets/look/look_features_icon5.png" alt=""><p>{{$t('look.col2.i19')}}</p></li>
                    </ul>
                </div>
                
            </div>
        </div>
        <div class="system" ref="animate4">
            <div class="box">
                <h3 :class="{'animated fadeInDown': animate4}">{{$t('look.col3.i1')}}</h3>
                <div class="smart" :class="{'animated fadeIn delay-1s': animate4}">
                    <div class="left">
                        <img src="../../assets/look/look_system_device.png" alt="">
                    </div>
                    <div class="right">
                        <ul>
                            <li>
                                <h4>{{$t('look.col3.i2')}}</h4>
                                <p>{{$t('look.col3.i3')}}</p>
                            </li>
                            <li>
                                <h4>{{$t('look.col3.i4')}}</h4>
                                <p>{{$t('look.col3.i5')}}</p>
                            </li>
                            <li>
                                <h4>{{$t('look.col3.i6')}}</h4>
                                <p>{{$t('look.col3.i7')}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="teacher">
                    <div class="left" ref="animate5" :class="{'animated fadeIn': animate5}">
                        <p>{{$t('look.col3.i8')}}  </p>
                        <p>{{$t('look.col3.i9')}}</p>
                        <p>{{$t('look.col3.i10')}}</p>
                        <p>{{$t('look.col3.i11')}}</p>
                    </div>
                    <div class="right">
                        <img src="../../assets/look/look_system_pic.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="applicable" ref="animate5">
             <div class="box">
                <h3 :class="{'animated fadeIn': animate5}">{{$t('look.col4.i1')}}</h3>
                <div class="content" :class="{'animated fadeIn delay-1s': animate5}">
                    <h4>{{$t('look.col4.i2')}}</h4>
                    <ul style="width: 690px;">
                        <li>{{$t('look.col4.i3')}}</li>
                        <li>{{$t('look.col4.i4')}}</li>
                        <li>{{$t('look.col4.i5')}}</li>
                        <li>{{$t('look.col4.i6')}}</li>
                        <li>{{$t('look.col4.i7')}}</li>
                        <li>{{$t('look.col4.i8')}}</li>
                    </ul>
                    <img src="../../assets/look/look_appli_pic1.png" alt="">
                </div>
                <div class="content content2"  :class="{'animated fadeIn delay-2s': animate5}">
                    <h4>{{$t('look.col4.i9')}}</h4>
                    <img src="../../assets/look/look_appli_pic2.png" alt="">
                    <ul>
                        <li>{{$t('look.col4.i10')}}</li>
                        <li>{{$t('look.col4.i11')}} </li>
                        <li>{{$t('look.col4.i12')}}</li>
                        <li>{{$t('look.col4.i13')}} </li>
                        <li>{{$t('look.col4.i14')}}</li>
                        <li>{{$t('look.col4.i15')}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="build" ref="animate6">
            <div class="box" :class="{'animated fadeInDown': animate6}">
                <ul>
                    <li>
                        <h4>{{$t('look.col5.i1')}}</h4>
                        <p>{{$t('look.col5.i2')}}</p>
                        <p>{{$t('look.col5.i3')}}</p>
                    </li>
                    <li><img src="../../assets/look/look_phone.png" alt=""></li>
                    <li>
                        <h4>{{$t('look.col5.i4')}}</h4>
                        <p>{{$t('look.col5.i5')}}</p>
                        <p>{{$t('look.col5.i6')}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <popup :show.sync="showPopup"></popup>
        <Footer />
    </div>
</template>
<script>
import Head from '../../components/head';
import Footer from '../../components/footer';
import Popup from '../../components/popup';
import scroll from '../mixin/scroll';
export default {
    components: {
        Head,
        Footer,
        Popup,
    },
    mixins: [scroll],
    data() {
        return {
            showPopup: false,
            refArray: [
                {ref: 'animate1', show: 'animate1', offset: 20},
                {ref: 'animate2', show: 'animate2',},
                {ref: 'animate3', show: 'animate3',},
                {ref: 'animate4', show: 'animate4',},
                {ref: 'animate5', show: 'animate5',},
                {ref: 'animate6', show: 'animate6',},
                {ref: 'animate7', show: 'animate7',},
                {ref: 'animate8', show: 'animate8',},
                {ref: 'animate9', show: 'animate9',},
            ],
            animate1: false,
            animate2: false,
            animate3: false,
            animate4: false,
            animate5: false,
            animate6: false,
            animate7: false,
            animate8: false,
            animate9: false,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
    }
}
</script>
<style lang="less">
.look {
    height: 100%;
    .banner {
        font-size: 0;
        background:url('../../assets/look/look_top_bg.jpg') no-repeat;
        background-position: center;
        background-size: cover;
        height: 639px;
        display: flex;
        align-items: center;
        .box {
            margin: 0 auto;
            width: 1200px;
            display: flex;
            .left {
                flex: 1;
                margin-right: 40px;
                .title {
                    margin: 50px 0 18px;
                    font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                    line-height: 1.5;
                    color: #ffffff;
                    font-size: 24px;
                }
                p {
                    
                    font-family: PingFangSC-Regular, PingFang SC, HelveticaNeue, Arial, sans-serif;
                    color: #ffffff;
                    font-size: 18px;
                    line-height: 34px;
                }
            }
            .right {
                img {
                    width: 560px;
                }
            }
        }
    }
    .pain-points {
        width: 100%;
        height: 410px;
        background: linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(152, 152, 152, 0.1) 100%);
        .box {
            background:#fff url('../../assets/look/look_points_bg.png') no-repeat top center;
            background-size: 609px 203px;
            box-sizing: border-box;
            padding: 50px 70px 0px;
            margin: 0 auto;
            width: 1200px;
            position: relative;
            top: -102px;
            height: 510px;
            box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
            h1 {
                width: 100%;
                text-align: center;
                font-size: 48px;
                font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                color: #000000;
                line-height: 48px;
                height: 48px;
            }
            ul {
                margin-top: 50px;
                display: flex;
                justify-content: space-between;
                li {
                    position: relative;
                    text-align: center;
                    width: 328px;
                    img {
                        width: 100px;
                    }
                    .info {
                        margin-top: 20px;
                        color: #000000;
                        p {
                            font-size: 24px;
                            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                            font-weight: bold;
                        }
                    }
                    .box-desc {
                        text-align: left;
                        margin-top: 18px;
                        font-size: 14px;
                        font-family: HelveticaNeue, Arial, sans-serif;
                        color: #666666;
                        line-height: 20px;
                        p {
                            margin-bottom: 20px;
                        }
                    }
                }

            }
        }
        
    }
    .product {
        background: #ffffff;
        margin-top: 94px;
        margin-bottom: 80px;
        h3 {
            width: 1200px;
            margin: 0 auto;
            font-size: 48px;
            margin-bottom: 60px;
        }
        .box {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            .left {
                width: 600px;
                margin-right: 80px;
                img {
                    width: 100%;
                }
                div {
                    margin-top: 40px;
                    font-size: 18px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    color: #000000;
                    line-height: 30px;
                }
            }
            .right {
                h4 {
                    font-size: 30px;
                    font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                    color: #000000;
                    line-height: 30px;
                }
                ul {
                    margin-top: 40px;
                    font-size: 18px;
                    font-family: HelveticaNeue-Medium, HelveticaNeue, Arial, sans-serif;
                    font-weight: 500;
                    color: #2B3BBB;
                    line-height: 18px;
                    li {
                        width: auto;
                        height: 60px;
                        line-height: 60px;
                        background: #F2F3FF;
                        border-radius: 30px;
                        display: flex;
                        img {
                            width: 48px;
                            height: 48px;
                            margin: 6px 12px 0 7px;
                        }
                    }
                    li:nth-of-type(1){
                        width: 352px;
                    }
                    li:nth-of-type(2){
                        width: 374px;
                        background: #EEF3FF;
                        color:#3971FF;
                    }
                    li:nth-of-type(3){
                        width: 484px;
                        background: #FFF6EC;
                        color:#FD8E0D;
                    }
                    li:nth-of-type(4){
                        width: 431px;
                        line-height: 20px;
                        background: #F0FAEF;
                        color: #3F9234;
                        p {
                            margin-top: 10px;
                        }
                    }
                    li:nth-of-type(5){
                        width: 513px;
                        color: #438CF7;
                        background: #EEF5FF;
                    }
                    li~li {
                        margin-top: 30px;
                    }
                }
            }
           
        }
    }

    .system {
        background:url('../../assets/look/look_system_bg.jpg') no-repeat;
        background-position: center;
        background-size: cover;
        height: 994px;
        .box {
            width: 1200px;
            margin: 0 auto;
            padding-top: 80px;
            h3 {
                font-size: 48px;
                margin-bottom: 70px;
            }
            .smart {
                display: flex;
                .left {
                    margin-right: 25px;
                    img {
                        margin-top: 10px;
                        width:785px
                    }
                }
                .right {
                    li {
                        color: #000000;
                        h4 {
                            font-size: 24px;
                            margin-bottom: 20px;
                            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                            line-height: 24px;
                        }
                        p {
                            font-size: 16px;
                            font-family: HelveticaNeue, Arial, sans-serif;
                            line-height: 26px;
                        }
                    }
                    li~li {
                        margin-top:70px;
                    }
                }
            }
            .teacher {
                margin-top: 60px;
                position: relative;
                height: 374px;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px 0px rgba(11, 10, 32, 0.15);
                display: flex;
                overflow: hidden;
                .left {
                    width: 561px;
                    box-sizing: border-box;
                    padding:67px 90px;
                    margin-right: 80px;
                    font-size: 24px;
                    font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                    font-weight: bold;
                    color: #FF8C19;
                    line-height: 60px;
                    &::after {
                        content: '';
                        position: absolute;
                        top: -560px;
                        left: -560px;
                        width: 1120px;
                        height: 1120px;
                        background: linear-gradient(5deg, rgba(255, 168, 128, 0.36) 0%, rgba(254, 162, 73, 0.1) 100%);
                        border-radius: 50%;
                    }
                }
                .right {
                    position: relative;
                    flex: 1;
                    padding-top: 79px;
                    &::after {
                        content: '';
                        position: absolute;
                        top: -38px;
                        left: 80px;
                        width: 451px;
                        height: 451px;
                        opacity: 0.2;
                        border: 3px solid #F59F44;
                        border-radius: 50%;
                        z-index: 1;
                    }
                    img {
                        width:500px;
                        position: relative;
                        z-index: 2;
                    }
                }
            }
        }
    }
    .applicable {
        margin-top: 169px;
        background: #fff;
        margin-bottom: 100px;
        .box {
            width: 1200px;
            margin: 0 auto;
            h3 {
                font-size: 48px;
                margin-bottom: 60px;
            }
            .content {
                width: 957px;
                height: 386px;
                box-sizing: border-box;
                background: #628CFA;
                padding-top: 54px;
                padding-left: 50px;
                position: relative;
                margin-bottom: 30px;
                h4 {
                    font-size: 24px;
                    font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                    color: #FFFFFF;
                    margin-bottom: 23px;
                }
                ul {
                    font-size: 16px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    li {
                        padding-left: 26px;
                        position: relative;
                        color: #FFFFFF;
                        line-height: 20px;
                        &::before {
                            position: absolute;
                            content: '';
                            width: 10px;
                            height: 10px;
                            background: #FFFFFF;
                            left: 0;
                            top: 5px;
                        }
                    }
                    li ~ li {
                        margin-top: 16px;
                    }

                }
                img {
                    position: absolute;
                    width: 450px;
                    bottom:0;
                    right:-243px;
                }
            }
            .content2 {
                height: 445px;
                background: #F59F44;
                margin-left: 243px;
                padding-left: 306px;
                box-sizing: border-box;
                ul {
                    line-height: 30px;
                    padding-right: 58px;
                   
                }
                img {
                    position: absolute;
                    width: 500px;
                    top:0;
                    left:-243px;
                }
            }
        }
    }
    .build {
        background:url('../../assets/look/look_ending_bg.jpg') no-repeat;
        background-position: center;
        background-size: cover;
        height: 550px;
        overflow: hidden;
        .box {
            width: 1200px;
            margin: 0 auto;
            color: #FFFFFF;
            ul {
                display: flex;
                li {
                    width:390px;
                    h4 {
                        margin-top: 140px;
                        font-size: 24px;
                        font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                        line-height: 30px;
                        padding-left: 20px;
                        position: relative;
                        &::before{
                            position: absolute;
                            content: '';
                            width: 6px;
                            height: 50px;
                            background: #628CFA;
                            left: 0;
                            top: 5px;
                        }
                    }
                    p {
                        margin-top: 40px;
                        font-size: 16px;
                        font-family: HelveticaNeue, Arial, sans-serif;
                        line-height: 26px;
                    }
                }
                li:nth-of-type(2){
                    width: 340px;
                    margin:0 50px 0 40px;
                    position: relative;
                    &::before{
                        position: absolute;
                        content: '';
                        width: 340px;
                        height: 340px;
                        background: #F59F44;
                        top:107px;
                        opacity: 0.85;
                        border-radius: 50%;
                        z-index: 1;
                    }
                    img{
                        margin-top: 76px;
                        width:198px;
                        position: absolute;
                        z-index: 2;
                        left:70px;
                    }
                }
            }
        }
    }
}
.lang-ru {
    .look .product .box .right ul li:nth-of-type(2) {
        width: 480px;
    }
    .look .product .box .right ul li:nth-of-type(3) p{
        line-height: 20px;
        padding-top: 8px;
        box-sizing: border-box;
    }
    .look .product .box .right ul li:nth-of-type(4) {
        width: 480px;
    }
    .look .product .box .right ul li:nth-of-type(5) p{
        line-height: 20px;
        padding-top: 8px;
    }
    .look .system .box .teacher .left {
        padding-top: 37px;
    }
}
.lang-fr {
    .look .product .box .right ul li:nth-of-type(1) {
        width: 480px;
    }
    .look .product .box .right ul li:nth-of-type(2) {
        width: 480px;
    }
    .look .product .box .right ul li:nth-of-type(3) p{
        line-height: 20px;
        padding-top: 8px;
        box-sizing: border-box;
    }
    .look .product .box .right ul li:nth-of-type(4) {
        width: 490px;
    }
    .look .product .box .right ul li:nth-of-type(5) p{
        line-height: 20px;
        padding-top: 8px;
    }
    .look .system .box .teacher .left {
        padding-top: 37px;
        font-size: 20px;
    }
}
</style>